<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['create']);

const { t } = useI18n();
</script>

<template>
  <article
    class="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-xl border border-n-weak bg-n-background px-6 py-8 text-center"
    :class="compact ? 'min-h-[180px] py-6' : ''"
  >
    <h3 class="m-0 text-base font-semibold text-n-slate-12">
      {{ t('AI_AGENTS.CREATE_CARD.TITLE') }}
    </h3>
    <p class="m-0 max-w-xs text-sm text-n-slate-11">
      {{ t('AI_AGENTS.CREATE_CARD.DESCRIPTION') }}
    </p>
    <Button
      :label="t('AI_AGENTS.CREATE_CARD.BUTTON')"
      icon="i-lucide-bot"
      outline
      slate
      sm
      class="!bg-n-background !text-[15px] !font-medium"
      @click="emit('create')"
    />
  </article>
</template>
